export default __webpack_public_path__ + "static/media/ACUTE-BRONCHITIS.af850d25.png";